export default "__VITE_ASSET__BBXylTAF__"